<script setup lang="ts">
import { SunIcon, MoonIcon } from "lucide-vue-next";
import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
} from "@/components/ui/navigation-menu";
import Button from "./ui/button/Button.vue";
import { toggleDarkMode } from "@/darkmode.js";
import { isDarkMode } from "@/darkmode.js";

defineProps({
  username: {
    type: String,
    required: true,
  },
  avatarUrl: {
    type: String,
    required: true,
  },
  isLoggedIn: {
    type: Boolean,
    default: true,
  },
});


</script>

<template>
  <div class="h-full w-full flex flex-row">
    <NavigationMenu class="h-full w-full">
      <NavigationMenuList
        class="dark:text-foreground flex flex-row justify-between items-center h-full w-full font-semibold px-20">
        <!-- Left-aligned items -->
        <div class="flex flex-row gap-3">
          <NavigationMenuItem class="flex-none">
            <NavigationMenuLink as-child class="px-4 py-2 text-xl">
              <a href="/#/">Home</a>
            </NavigationMenuLink>
          </NavigationMenuItem>
          <NavigationMenuItem class="flex-none">
            <NavigationMenuLink as-child class="px-4 py-2 text-xl">
              <a href="/#/profile">Profile</a>
            </NavigationMenuLink>
          </NavigationMenuItem>
          <NavigationMenuItem class="flex-none">
            <NavigationMenuLink as-child class="px-4 py-2 text-xl">
              <a href="/#/lan-info">Bookings</a>
            </NavigationMenuLink>
          </NavigationMenuItem>
        </div>
      </NavigationMenuList>
    </NavigationMenu>
    <div class="grow"></div>
    <NavigationMenu class="h-full w-full">
      <NavigationMenuList
        class="dark:text-foreground flex flex-row justify-between items-center h-full w-full font-semibold px-20">
        <!-- Right-aligned items -->
        <div class="flex flex-row gap-3 items-center">
          <NavigationMenuItem class="flex-none">
            <NavigationMenuLink as-child class="px-4 py-4 text-xl">
              <Button variant="ghost" size="icon-lg" @click="toggleDarkMode">
                <SunIcon v-if="!isDarkMode" class="dark:text-foreground"></SunIcon>
                <MoonIcon v-if="isDarkMode" class="dark:text-foreground"></MoonIcon>
              </Button>
            </NavigationMenuLink>
          </NavigationMenuItem>

          <NavigationMenuItem v-if="isLoggedIn" class="flex-none">
            <RouterLink to="/profile">
              <NavigationMenuLink as-child class="px-4 py-4 text-xl font-semibold gap-3">
                <div class="flex flex-row items-center">
                  <p class="mr-2">{{ username }}</p>
                  <img :src="avatarUrl" alt="User's Avatar" class="rounded-md w-10 h-10" />
                </div>
              </NavigationMenuLink>
            </RouterLink>
          </NavigationMenuItem>
          <NavigationMenuItem v-else class="flex-none">
            <NavigationMenuLink as-child class="px-4 py-4 text-xl">
              <RouterLink to="/profile">
                <Button>Sign In</Button>
              </RouterLink>
            </NavigationMenuLink>
          </NavigationMenuItem>
        </div>
      </NavigationMenuList>
    </NavigationMenu>
  </div>
</template>
